import moment from 'moment';

const isCardValid = (cardExpiration) =>
	moment(cardExpiration, 'MM/YYYY').endOf('month').diff(moment(), 'days') > 0;

export default isCardValid;
